/**
 * quando o mesmo nome de evento é reutilizado, 
 * é necessário limpar os parâmetros para cada novo evento
 * nesse projeto todos os eventos estão sendo chamados de 'checkout'
 */
export type EventParams = {
    event?: string,
    secao?: string,
    nome_campo?: string,
    tipo_acao?: 'click' | 'show' | 'erro' | 'abrir' | 'fechar' | 'sucesso',
    tipo_oferta?: string,
    method?: 'Google' | 'Facebook' | 'Interno',
    ecommerce?: Ecommerce
    id_pedido?: string
}

type EcommerceItem = {
    item_name: string;
    item_id: string;
    price: number;
}

type Ecommerce = {
    currency: 'BRL',
    value: number, /** price * quantity - discount */
    transaction_id?: string,
    payment_type?: "Credit Card",
    items: EcommerceItem[]
}

const defaultParams = {
    event: 'checkout',
    secao: undefined,
    nome_campo: undefined,
    tipo_acao: undefined,
    tipo_oferta: undefined,
}

export const sendGTMGA4Event = (obj: EventParams | null) => {
    // @ts-ignore
    if (!obj) return window.dataLayerGA4.push({ ecommerce: null });  // Clear the previous ecommerce object.
    obj = (typeof obj === 'object' ? {...defaultParams, ...obj} : defaultParams) as EventParams
    // @ts-ignore
    window.dataLayerGA4 = window.dataLayerGA4 || []
    // @ts-ignore
    window.dataLayerGA4.push(obj)
}